import * as React from 'react';
import styled from 'styled-components';
import Values from 'values.js';

import { ClydeButton } from './ClydeButton';

import { IButtonColors } from 'src/types/IButton';
import { useTheme } from 'src/providers/ThemeProvider';

const StyledButton = styled(ClydeButton)<{ colors: IButtonColors }>`
  ${({ colors }) => (`
    background: ${colors.background};
    color: ${colors.text};
    border: 1px solid ${colors.border};

    &:focus, &:hover {
      background: ${colors.backgroundHover};
      // border-color: ?
    }

    &:active {
      background: ${colors.backgroundPressed};
    }
  `)}
`;

type PrimaryButtonProps = React.ComponentPropsWithoutRef<'button'>;

// TODO: fix this any!
export const PrimaryButton = React.forwardRef<HTMLButtonElement, PrimaryButtonProps>((props, ref) => {
  const { merchantColor } = useTheme();

  const color = React.useMemo(() => new Values(merchantColor), [merchantColor]);
  const colors = {
    background: color.hexString(),
    backgroundHover: color.tint(15).hexString(),
    backgroundPressed: color.tint(30).hexString(),
    border: 'transparent',
    // text: getTextColor(color.hexString()),
    text: '#fff', // NOTE: we only support white text for now (TODO: double-check this)
  };

  return <StyledButton colors={colors} ref={ref} {...props} />;
});

PrimaryButton.displayName = 'PrimaryButton';
